import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrcamentosEPacotesInserirComponent } from './orcamentos-e-pacotes-inserir.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: OrcamentosEPacotesInserirComponent}
  ])],
  exports: [RouterModule]
})
export class OrcamentosEPacotesInserirRoutingModule { }
